import type { Dictionary } from "./translations";

export const zhTW: Dictionary = {
  "meta.title": "AgentBuck - AI 模型價格比較",
  "meta.description": "比較主流 AI 模型的 API 價格，並根據實際 Token 用量估算每月成本。",
  "nav.prices": "模型價格",
  "nav.calculator": "成本計算器",
  "nav.providers": "供應商",
  "nav.guide": "價格指南",
  "nav.method": "計算方法",
  "aria.home": "AgentBuck 首頁",
  "aria.language": "選擇語言",
  "aria.navigation": "主要導覽",
  "aria.breadcrumb": "麵包屑導覽",
  "aria.dark": "切換至深色模式",
  "aria.light": "切換至淺色模式",
  "title.dark": "深色模式",
  "title.light": "淺色模式",
  "hero.eyebrow": "AI API 價格資料庫",
  "hero.title": "找到適合預算的 AI 模型",
  "hero.subtitle": "以統一標準比較輸入、輸出和快取價格，再根據實際 Token 用量估算每月成本。",
  "stats.models": "可比較模型",
  "stats.providers": "主流供應商",
  "stats.updated": "資料更新時間",
  "common.loading": "載入中",
  "notice.snapshot": "即時資料暫時無法取得，正在顯示 2026 年 9 月 7 日的內建快照。",
  "common.retry": "重試",
  "common.home": "首頁",
  "common.models": "模型",
  "common.providers": "供應商",
  "common.from": "起價",
  "common.viewAll": "查看全部",
  "common.backPricing": "返回價格表",
  "share.quick": "分享此頁面",
  "share.kicker": "與團隊分享",
  "share.title": "分享此比較",
  "share.description": "分享此頁面，保留所選模型和完整用量假設。",
  "share.copy": "複製連結",
  "share.copied": "已複製連結",
  "share.more": "分享",
  "share.openComparison": "開啟分享頁面",
  "share.email": "電子郵件",
  "calculator.title": "每月成本計算器",
  "calculator.input": "每月輸入",
  "calculator.output": "每月輸出",
  "calculator.cache": "快取輸入占比",
  "calculator.million": "百萬 Token",
  "calculator.cheapest": "目前成本最低的 5 款模型",
  "calculator.perMonth": "預估 / 月",
  "prices.title": "模型價格",
  "prices.subtitle": "標準即時 API，美元 / 百萬 Token",
  "filter.open": "篩選",
  "filter.search": "搜尋模型或供應商",
  "filter.clearSearch": "清除搜尋",
  "filter.provider": "依供應商篩選",
  "filter.allProviders": "所有供應商",
  "filter.sort": "模型排序",
  "filter.favorite": "已收藏",
  "sort.monthly": "預估每月成本",
  "sort.input": "輸入價格",
  "sort.output": "輸出價格",
  "sort.context": "上下文視窗",
  "sort.newest": "最新發布",
  "cap.reasoning": "推理",
  "cap.tools": "工具呼叫",
  "cap.vision": "視覺",
  "cap.structured": "結構化輸出",
  "cap.openWeights": "開放權重",
  "results.found": "找到 {count} 款模型",
  "results.source": "價格依公開定價統一換算，請查閱供應商文件確認。",
  "column.compare": "比較",
  "column.model": "模型 / 供應商",
  "column.input": "輸入",
  "column.cached": "快取輸入",
  "column.output": "輸出",
  "column.monthly": "預估月費",
  "column.context": "上下文",
  "column.capabilities": "推理  工具  視覺",
  "column.actions": "操作",
  "action.officialDocs": "官方文件",
  "action.addCompare": "加入比較",
  "action.removeCompare": "移出比較",
  "action.addFavorite": "收藏模型",
  "action.removeFavorite": "取消收藏",
  "action.added": "已新增",
  "context.suffix": "上下文",
  "empty.title": "沒有符合條件的模型",
  "empty.description": "請嘗試其他搜尋詞，或清除能力篩選條件。",
  "empty.clear": "清除篩選",
  "home.exploreKicker": "探索模型目錄",
  "home.exploreTitle": "更多 AI 模型比較方式",
  "home.providersTitle": "依供應商瀏覽",
  "home.providersBody": "比較 OpenAI、Anthropic、Google、DeepSeek、Alibaba 等供應商的所有收錄模型。",
  "home.guideTitle": "閱讀價格指南",
  "home.guideBody": "了解 Token 配比、提示詞快取、上下文級距定價及影響 API 帳單的因素。",
  "home.open": "開啟",
  "providers.kicker": "供應商目錄",
  "providers.title": "AI 模型供應商",
  "providers.intro": "查看 AgentBuck 目錄中各大供應商統一換算的 API 價格、上下文上限和模型能力。",
  "providers.models": "{count} 款模型",
  "providers.starting": "最低輸入單價",
  "providers.view": "查看供應商",
  "provider.kicker": "供應商價格",
  "provider.titleSuffix": "API 價格",
  "provider.description": "依輸入價格、輸出價格、上下文視窗和正式環境所需能力，比較 {name} 的 {count} 款模型。",
  "provider.cheapest": "最低輸入價格",
  "provider.largestContext": "最大上下文",
  "provider.updated": "目錄更新時間",
  "model.kicker": "模型價格詳情",
  "model.title": "{name} API 價格",
  "model.descriptionFallback": "比較此模型的 API Token 單價、上下文上限、能力和預估每月成本。",
  "model.input": "輸入 / 百萬 Token",
  "model.cache": "快取輸入 / 百萬 Token",
  "model.output": "輸出 / 百萬 Token",
  "model.context": "上下文視窗",
  "model.maxOutput": "最大輸出",
  "model.released": "發布日期",
  "model.updated": "模型更新時間",
  "model.estimateTitle": "您的每月成本估算",
  "model.estimateBody": "依輸入 {input} 百萬 Token、輸出 {output} 百萬 Token 和 {cache}% 快取輸入計算。",
  "model.relatedTitle": "{provider} 的更多模型",
  "compare.pageTitle": "共用 AI 模型成本比較",
  "compare.pageBody": "使用此連結中儲存的用量假設，比較 Token 單價、上下文視窗、能力和每月成本。",
  "compare.emptyTitle": "此比較中沒有模型",
  "compare.emptyBody": "從價格表中選擇兩到三款模型，建立可分享的比較。",
  "compare.start": "選擇模型",
  "compare.usage": "共用用量",
  "notFound.title": "找不到頁面",
  "notFound.body": "頁面可能已移動，或此模型已不在目前目錄中。",
  "guide.kicker": "實用選購指南",
  "guide.title": "依實際工作負載比較 AI API 價格",
  "guide.intro": "最低輸入單價不一定代表最低總帳單。AgentBuck 將提示詞、快取提示詞和生成 Token 的費用合併，讓 GPT、Claude、Gemini、DeepSeek、Qwen、Grok 等模型在相同用量下進行比較。",
  "guide.inputTitle": "從 Token 配比開始",
  "guide.inputBody": "聊天機器人通常消耗更多輸入 Token，而程式開發代理和推理系統可能產生更多輸出。這會改變最具成本效益的模型選擇。",
  "guide.cacheTitle": "計入提示詞快取",
  "guide.cacheBody": "重複的系統提示詞和較長的共用上下文，會讓快取讀取價格成為關鍵因素。比較每月總成本前，請設定合理的快取占比。",
  "guide.fitTitle": "確認能力和上下文",
  "guide.fitBody": "只有模型滿足上下文視窗、視覺輸入、推理深度、結構化輸出和工具呼叫需求時，價格比較才有意義。",
  "faq.kicker": "常見問題",
  "faq.title": "AI 模型價格常見問題",
  "faq.q1": "AgentBuck 如何比較 AI 模型的 API 價格？",
  "faq.a1": "AgentBuck 將標準即時 API 價格統一為每百萬 Token 的美元價格，並分別列出輸入、快取輸入和輸出費用，同時提供供應商文件連結以供確認。",
  "faq.q2": "哪款 AI 模型的 API 最便宜？",
  "faq.a2": "沒有適用於所有情境的最便宜模型。結果取決於輸入輸出比例、快取使用情況和所需能力。輸入上方的每月用量，即可依實際工作負載為模型排序。",
  "faq.q3": "如何計算大型語言模型的預估每月成本？",
  "faq.a3": "將未快取輸入、快取輸入和輸出的用量分別乘以對應模型單價後加總。估算不含稅費、批次處理折扣、區域定價和長上下文附加費。",
  "faq.q4": "為什麼有些模型顯示為零美元？",
  "faq.a4": "部分供應商為特定模型提供免費或促銷使用。可用性和限制可能變動，在正式環境使用前請確認連結中的供應商文件。",
  "faq.q5": "價格資料多久更新一次？",
  "faq.a5": "AgentBuck 每六小時更新一次結構化價格目錄。模型表顯示上游最新的模型更新時間，實際計費仍以供應商條款為準。",
  "method.title": "資料與計算方法",
  "method.priceTitle": "價格基準",
  "method.priceBody": "採用標準即時 API 的美元 / 百萬 Token 價格，不含稅費、批次處理價格、區域加價和長上下文級距定價。",
  "method.sourceTitle": "資料來源",
  "method.sourceBefore": "將公開模型目錄和供應商價格頁面統一整理為可比較的資料集。",
  "method.sourceAfter": "AgentBuck 每六小時更新一次，並提供供應商文件連結供確認。",
  "method.costTitle": "成本估算",
  "method.costBody": "每月成本 = 一般輸入 + 快取輸入 + 輸出。此估算用於預算規劃，實際帳單以供應商控制台為準。",
  "footer.tagline": "讓每個 Token 都物有所值。",
  "footer.updated": "資料更新時間：{date}",
  "compare.selected": "已選 {count}/3",
  "compare.remove": "移除 {name}",
  "compare.button": "比較模型",
  "compare.kicker": "模型比較",
  "compare.title": "並排比較價格與能力",
  "compare.close": "關閉",
  "compare.input": "輸入 / 百萬 Token",
  "compare.cache": "快取 / 百萬 Token",
  "compare.output": "輸出 / 百萬 Token",
  "compare.monthly": "預估每月成本",
  "compare.context": "上下文",
  "compare.capabilities": "推理 / 工具 / 視覺",
  "compare.docs": "供應商文件",
  "compare.viewPrice": "查看價格",
  "nav.requestCalculator": "請求成本計算器",
  "home.calculatorTitle": "依請求量估算成本",
  "home.calculatorBody": "根據每日請求數、每次請求的 Token 數與快取命中率計算每月支出。",
  "home.compareDirectoryTitle": "瀏覽模型比較",
  "home.compareDirectoryBody": "從精選比較開始，或從價格表建立自己的比較。",
  "model.formulaTitle": "成本計算公式",
  "model.formulaBody": "每月成本 =（未快取輸入 Token × 輸入單價）+（快取輸入 Token × 快取讀取單價）+（輸出 Token × 輸出單價），均以每百萬 Token 計算。若未公布快取讀取單價，快取 Token 將以標準輸入單價估算。",
  "model.exampleTitle": "可重現範例",
  "model.exampleBody": "範例：{inputM} 輸入 Token（其中 {cachePercent}% 來自快取）與 {outputM} 輸出 Token，依此模型公開價格計算為 {total}——每百萬 Token 輸入 {inputRate}、快取輸入 {cacheRate}、輸出 {outputRate}。",
  "model.calculatorCta": "依每日請求量估算成本",
  "model.comparisonsTitle": "已收錄於以下精選比較",
};
